<template>
  <div class="page-container">
    <headerSection></headerSection>

    <!-- Hero Section -->
    <div class="hero-section">
      <div class="floating-ball ball-1"></div>
      <div class="floating-ball ball-2"></div>
      <div class="floating-ball ball-3"></div>

      <div class="container">
        <div class="hero-content">
          <div class="hero-icon-wrapper">
            <span class="hero-icon">🔥</span>
          </div>
          <h1 class="title-glow">{{ $t('continue_page.title') }}</h1>
          <p class="hero-description">ฝากต่อเนื่อง รับโบนัสทุกวัน</p>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="container main-content">
      <!-- Promotion Info Card -->
      <div class="promotion-card">
        <div class="promotion-header">
          <div class="promotion-name">
            {{ (this.continues && this.continues.promotion) ? this.continues.promotion.name : $t('continue_page.title2') }}
          </div>
          <div class="promotion-total">
            <span class="total-label">{{ $t('continue_page.title3') }}</span>
            <span class="total-value">{{ numberWithCommas(this.continues.total) }}</span>
          </div>
        </div>
      </div>

      <!-- Streak Progress Card -->
      <div class="streak-card">
        <div class="streak-header">
          <span class="streak-label">{{ $t('continue_page.title') }}</span>
          <span class="streak-count">{{ dots.length }}/7 วัน</span>
        </div>

        <!-- Progress Bar -->
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: `${(dots.length/7)*100}%` }"></div>
        </div>

        <!-- 7-Day Tracker -->
        <div class="days-grid">
          <div class="day-item" v-for="day in 7" :key="day"
               :class="{ 'active': day <= dots.length }">
            <div class="day-circle">
              <span v-if="day <= dots.length" class="day-check">✓</span>
              <span v-else class="day-number">{{ day }}</span>
            </div>
            <span class="day-label">วัน {{ day }}</span>
          </div>
        </div>
      </div>

      <!-- Claim Button -->
      <div class="claim-section">
        <button @click="moveContinuesToWallet()"
                :class="['claim-btn', { 'disabled': !(continues && continues.total > 0) }]"
                :disabled="!(continues && continues.total > 0) || disabled">
          {{ $t('partner_title7') }}
        </button>
      </div>

      <!-- Rules Section -->
      <div class="rules-card">
        <div class="rules-header">
          <span class="rules-icon">📋</span>
          <h5 class="rules-title">เงื่อนไขการรับโบนัส</h5>
        </div>
        <div class="rules-content">
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.member_7_days') }}</span>
          </div>
          <div class="rule-item highlight">
            <span class="rule-bullet">✨</span>
            <span class="rule-text">{{ $t('continue_page.rules.deposit_1000_bonus') }}</span>
          </div>
          <div class="rule-item highlight">
            <span class="rule-bullet">✨</span>
            <span class="rule-text">{{ $t('continue_page.rules.deposit_2000_bonus') }}</span>
          </div>
          <div class="rule-item highlight">
            <span class="rule-bullet">✨</span>
            <span class="rule-text">{{ $t('continue_page.rules.deposit_3000_bonus') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.no_bonus_deposit') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.casino_games_only') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.no_feature_buy') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.no_exceed_bonus') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.withdraw_3x') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.max_withdraw_3x') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.bonus_credit_only') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.credit_below_10') }}</span>
          </div>
          <div class="rule-item">
            <span class="rule-bullet">•</span>
            <span class="rule-text">{{ $t('continue_page.rules.auto_claim_time') }}</span>
          </div>
          <div class="rule-item warning">
            <span class="rule-bullet">⚠</span>
            <span class="rule-text">{{ $t('continue_page.rules.violation_warning') }}</span>
          </div>
        </div>
      </div>
    </div>

    <footerSection></footerSection>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import moment from 'moment-timezone'
import router from './../router'
const axios = require('axios').default
export default {
  name: 'continues',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue')
  },
  data: function () {
    return {
      continues: [],
      dots: [],
      disabled: false
    }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    moveContinuesToWallet () {
      if (this.continues.total && this.continues.key && !this.disabled) {
        this.disabled = true;
        this.$store.commit('user/SET_LOADING', true)
        this.$store.dispatch('user/moveCreditToWallet').finally((res) => {
          setTimeout(async () => {
            const eligibility = await this.$store.dispatch('user/checkBonusClaimEligibility', { type: 'continuous' })
            if (eligibility.blocked) {
              this.showBonusClaimBlockedAlert(eligibility)
              this.$store.commit('user/SET_LOADING', false)
              return
            }

            let check = false
            await firebase.firestore().collection('history').where('userkey', '==', this.user.key).where('status', 'not-in', ['ดำเนินการแล้ว', 'ยกเลิก']).where('type', '==', 'ถอน').limit(1).get().then((result) => {
              if (result.size) {
                check = true
              }
            })
            if (!check) {
              axios.get(`https://time2lucky.apifast.xyz/qcontinuous/continuous/${this.continues.key}`)
              setTimeout(() => {
                this.getContinues()
                this.$store.commit('user/SET_LOADING', false)
              }, 2000)
            } else {
              this.$swal({ icon: 'error', title: this.$t('partner_page.alert_title'), text: this.$t('continue_page.alert_wait_withdraw') })
              this.$store.commit('user/SET_LOADING', false)
            }
          }, 2000)
        }).catch(err => { console.error(err) })
        setTimeout(() => {
          this.disabled = false;
        }, 3000);
      }
    },
    showBonusClaimBlockedAlert (eligibility) {
      const total = Number(eligibility.promotionBalanceTotal || eligibility.totalBalance || 0).toFixed(2)
      const limit = Number(eligibility.limit || 10).toFixed(2)
      const lineLink = this.$store.getters['settings/adminContactLineLink'] || this.$store.getters['settings/linkLine'] || 'https://lin.ee/tqR1wJD'
      return this.$swal({
        icon: 'error',
        title: 'เงื่อนไข',
        html: `ต้องมียอดคงเหลือรวมต่ำกว่า ${limit} บาท ถึงรับได้ค่ะ (ยอดรวมปัจจุบัน ${total} บาท)<br><br>สอบถามข้อมูลเครดิตเพิ่มเติม กรุณาติดต่อแอดมิน`,
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ติดต่อแอดมิน',
        reverseButtons: false
      }).then((swalResult) => {
        if (swalResult && swalResult.dismiss === 'cancel' && lineLink) {
          window.open(lineLink, '_blank')
        }
        return swalResult
      })
    },
    numberWithCommas (x) {
	  if (!x) x = 0
      return x.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        const _user = JSON.parse(user)
        return _user
      } else {
        firebase.auth().signOut()
        localStorage.removeItem('userData')
        router.replace('/login')
      }
    },
    async getContinues () {
      const user = this.getUserId()
      if (user) {
        await firebase.firestore().collection('continuous_deposit').where('date', '==', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).where('status', '==', false).get().then((snapshot) => {
          if (!snapshot.size) {
            this.continues = []
            this.dots = []
          }
          snapshot.forEach((doc) => {
            const data = doc.data()
            data.key = doc.id
            this.continues = data
          })
        })
        // if (this.continues && this.continues.promotion) {
        //   for (let i = 0; i < Number(this.continues.promotion.numday); i++) {
        //     this.dots.push(true)
        //   }
        // } else {
          const fixed = 1000
          let last = {}
          await firebase.firestore().collection('continuous_deposit_all').where('userkey', '==', user.key).where('status', '==', true).orderBy('date', 'desc').limit(1).get().then((snapshot) => {
            snapshot.forEach((doc) => {
              const data = doc.data()
              data.key = doc.id
              last = data
            })
          })
          const dateCheck = []
          if (last && last.date) {
            await firebase.firestore().collection('daily_deposit').where('createdate', '>', last.date).where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(7).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          } else {
            await firebase.firestore().collection('daily_deposit').where('createdate', '<=', moment().tz('Asia/Bangkok').add(-1, 'days').format('YYYY-MM-DD')).where('userkey', '==', user.key).orderBy('createdate', 'desc').limit(7).get().then((snapshot) => {
              snapshot.forEach((doc) => {
                if (doc.data().total >= fixed) {
                  dateCheck[doc.data().createdate] = true
                }
              })
            })
          }
          if (dateCheck) {
            for (let i = 1; i <= 7; i++) {
              if (dateCheck[moment().tz('Asia/Bangkok').add(-i, 'days').format('YYYY-MM-DD')]) {
                this.dots.push(true)
              } else {
                break
              }
            }
          // }
        }
      }
    }
  },
  mounted () {
    this.scrollToTop()
    this.getContinues()
  }
}
</script>

<style scoped>
/* Page Container */
.page-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #09030f 0%, #220735 50%, #09030f 100%);
  padding-bottom: 100px;
  font-family: 'Kanit', sans-serif;
}

/* Hero Section */
.hero-section {
  position: relative;
  padding: 80px 0 30px;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(112, 32, 170, 0.1) 0%, transparent 100%);
}

.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-icon-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  animation: bounce 2s ease-in-out infinite;
}

.hero-icon {
  font-size: 64px;
  display: block;
  filter: drop-shadow(0 4px 15px rgba(183, 90, 255, 0.4));
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
}

.title-glow {
  font-size: 36px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 15px;
  text-shadow:
    0 0 20px rgba(183, 90, 255, 0.5),
    0 0 40px rgba(112, 32, 170, 0.3),
    0 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

/* Floating Balls */
.floating-ball {
  position: absolute;
  border-radius: 50%;
  opacity: 0.15;
  pointer-events: none;
  z-index: 1;
}

.floating-ball.ball-1 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #7020aa, #e0b5ff);
  top: -50px;
  left: -100px;
  animation: float1 6s ease-in-out infinite;
}

.floating-ball.ball-2 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #e0b5ff, #7020aa);
  top: 50%;
  right: -75px;
  animation: float2 8s ease-in-out infinite;
}

.floating-ball.ball-3 {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #220735, #7020aa);
  bottom: 20%;
  left: 10%;
  animation: float3 7s ease-in-out infinite;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(30px, 20px) rotate(180deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(-20px, 30px) rotate(-180deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(20px, -20px) rotate(180deg); }
}

/* Main Content */
.main-content {
  padding: 0 20px;
  margin-top: 20px;
}

/* Promotion Card */
.promotion-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(112, 32, 170, 0.2);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.promotion-header {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: center;
}

.promotion-name {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.promotion-total {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.total-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 5px;
}

.total-value {
  font-size: 24px;
  font-weight: 700;
  color: #e0b5ff;
  text-shadow: 0 0 15px rgba(183, 90, 255, 0.5);
}

/* Streak Card */
.streak-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(112, 32, 170, 0.2);
  border-radius: 12px;
  padding: 30px;
  margin-bottom: 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.streak-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.streak-label {
  font-size: 18px;
  color: #fff;
  font-weight: 600;
}

.streak-count {
  font-size: 24px;
  color: #e0b5ff;
  font-weight: 700;
  text-shadow: 0 0 15px rgba(183, 90, 255, 0.5);
}

/* Progress Bar */
.progress-bar {
  width: 100%;
  height: 8px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 30px;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #7020aa, #e0b5ff);
  border-radius: 10px;
  transition: width 0.5s ease;
  box-shadow: 0 0 10px rgba(183, 90, 255, 0.5);
}

/* Days Grid */
.days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  margin-top: 20px;
}

.day-item {
  text-align: center;
}

.day-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid rgba(112, 32, 170, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 8px;
  font-size: 20px;
  transition: all 0.3s ease;
}

.day-item.active .day-circle {
  background: linear-gradient(135deg, #7020aa, #e0b5ff);
  border-color: #e0b5ff;
  box-shadow: 0 0 20px rgba(183, 90, 255, 0.5);
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.day-check {
  color: #000;
  font-weight: 700;
}

.day-number {
  color: rgba(255, 255, 255, 0.5);
  font-weight: 600;
}

.day-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

/* Claim Section */
.claim-section {
  text-align: center;
  margin-bottom: 30px;
}

.claim-btn {
  background: linear-gradient(135deg, #7020aa, #32074d);
  border: none;
  border-radius: 8px;
  padding: 15px 40px;
  color: #fff1d3;
  font-weight: 600;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow:
    0 4px 15px rgba(183, 90, 255, 0.4),
    0 0 20px rgba(183, 90, 255, 0.3);
  font-family: 'Kanit', sans-serif;
}

.claim-btn:hover:not(.disabled) {
  transform: translateY(-2px);
  box-shadow:
    0 6px 25px rgba(183, 90, 255, 0.5),
    0 0 30px rgba(183, 90, 255, 0.4);
  filter: brightness(1.1);
}

.claim-btn.disabled {
  background: linear-gradient(135deg, #666, #444);
  color: #999;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.6;
}

/* Rules Card */
.rules-card {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(112, 32, 170, 0.2);
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}

.rules-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(112, 32, 170, 0.2);
}

.rules-icon {
  font-size: 28px;
  filter: drop-shadow(0 0 10px rgba(183, 90, 255, 0.3));
}

.rules-title {
  color: #e0b5ff;
  font-weight: 600;
  font-size: 18px;
  margin: 0;
}

.rules-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rule-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.rule-item:hover {
  background: rgba(112, 32, 170, 0.05);
}

.rule-item.highlight {
  background: rgba(112, 32, 170, 0.1);
  border-left: 3px solid rgba(183, 90, 255, 0.5);
  padding-left: 15px;
}

.rule-item.warning {
  background: rgba(255, 100, 100, 0.1);
  border-left: 3px solid rgba(255, 100, 100, 0.5);
  padding-left: 15px;
}

.rule-bullet {
  flex-shrink: 0;
  color: #e0b5ff;
  font-weight: 600;
  font-size: 16px;
}

.rule-item.warning .rule-bullet {
  color: #ff6464;
}

.rule-text {
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  font-size: 14px;
}

.rule-item.highlight .rule-text {
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
}

/* Responsive Design */
@media screen and (max-width: 768px) {
  .hero-section {
    padding: 75px 0 25px;
  }

  .title-glow {
    font-size: 28px;
  }

  .hero-icon {
    font-size: 48px;
  }

  .floating-ball.ball-1 {
    width: 150px;
    height: 150px;
  }

  .floating-ball.ball-2 {
    width: 100px;
    height: 100px;
  }

  .floating-ball.ball-3 {
    width: 80px;
    height: 80px;
  }

  .promotion-header {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .promotion-total {
    align-items: center;
  }

  .days-grid {
    gap: 8px;
  }

  .day-circle {
    width: 45px;
    height: 45px;
    font-size: 18px;
  }
}

@media screen and (max-width: 480px) {
  .hero-section {
    padding: 70px 0 20px;
  }

  .title-glow {
    font-size: 24px;
  }

  .hero-description {
    font-size: 14px;
  }

  .hero-icon {
    font-size: 40px;
  }

  .streak-card {
    padding: 20px 15px;
  }

  .days-grid {
    gap: 5px;
  }

  .day-circle {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .day-label {
    font-size: 11px;
  }

  .claim-btn {
    padding: 12px 30px;
    font-size: 16px;
  }

  .rules-card {
    padding: 20px 15px;
  }

  .rule-text {
    font-size: 13px;
  }
}
</style>
